import { ServiceIcon, ServiceIconSize } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

type Props = {
  serviceName: string;
  src: string;
  size: ServiceIconSize;
  hasBorder?: boolean;
  hasShadow?: boolean;
};

export default function ServiceIconWithFallback({
  serviceName,
  src,
  size,
  hasBorder = false,
  hasShadow = false,
}: Props) {
  if (serviceName && src) {
    return (
      <ServiceIcon
        alt={`${serviceName} icon`}
        hasBorder={hasBorder}
        size={size}
        hasShadow={hasShadow}
        serviceName={serviceName}
        src={src}
      />
    );
  }

  return (
    <div style={{ height: size }}>
      <Icon aria-hidden name="miscBolt" size={size} color="GrayWarm9" />
    </div>
  );
}
